import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';

import { Skeleton } from '@material-ui/lab';
import { Box, ButtonBase } from '@material-ui/core';

class InfoCard extends React.Component {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        skeleton: PropTypes.bool,
        grow: PropTypes.number,
        onClick: PropTypes.func,
        inline: PropTypes.bool,
        active: PropTypes.bool
    };

    constructor (props) {
        super(props);
    }

    render () {
        const { classes, style, className, skeleton, grow, children, active, inline, onClick, ...otherProps } =this.props;

        const flex = {
            ...(grow && { flexGrow: grow })
        };

        if (skeleton) { return <Skeleton style={flex} animation="wave" height={75} variant="rect" />; }


        return (
            <div
                className={classnames(
                    classes.root, 
                    active && classes.active, 
                    onClick && classes.button, 
                    inline && classes.inline, 
                    className
                )}
                style={{ ...style, ...flex }}
                onClick={onClick}
                {...otherProps}
            >
                {children}
            </div>
        );
    }
}

const style = theme => ({
    root: {
        color: theme.palette.text.primary,
        padding: theme.constants.spacing.md,
        border: `1px solid ${theme.palette.background.border}`,
        borderRadius: theme.constants.radius.sm,
        '&:not(:last-child)': {
            marginRight: theme.constants.spacing.md
        },
        '&>  *':{
            ...theme.typography.body1,
            display: 'flex',
            alignItems: 'center',
            lineHeight: 'initial',
            '&:first-child': {
                height: '22px',
                marginBottom: '10px',
                '&> svg': {
                    fontSize: '1em',
                    marginLeft: '6px'
                }
            },
            '&:last-child': {
                fontSize: '22px',
                fontWeight: '500',
                '&> svg': {
                    fontSize: '1em',
                    marginRight: '8px'
                }
            },
        }
    },
    inline: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        '&>  *:first-child':{
            margin: 0
        }
    },
    button: {
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: `${theme.palette.grey.variant5}1A`
        }
    },
    active: {
        backgroundColor: `${theme.palette.grey.variant5}1A`
    }
});

export default withStyles(style)(InfoCard);